import {BranchOptionsItem} from '@dms/api/shared';

export type BranchState = {
  activeBranchId: string;
  defaultBranchId?: string;
  userOptions?: Array<BranchOptionsItem>;
};
